import styled from "styled-components";
import { colors } from "@/constants";

export const OfflineMessage = styled.div`
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  width: fit-content;
  color: ${colors.brand.white};
`;

export const OfflineOffset = styled.div`
  height: 34px;
`;

export const OfflineMessageContainerStyle = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  position: fixed;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateX(-50%);
  backdrop-filter: blur(4px);
  z-index: 9999999999;
  height: 34px;
  max-width: var(--mobile);
  background-color: ${colors.alert.red200};
  box-shadow: 0px 4px 4px 0px ${colors.shadown2};
`;